module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Angle-double-down-e3b7b1cc94ea40687ff67a41a7feab7c.svg";